import type { ReactNode } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import MobileHeader from "../layout/MobileHeader";
import { MobileContent } from "../layout/MobileContent";

/** En celular agrega el encabezado y márgenes del layout móvil de Atomic. */
export const MobilePage = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const isMobile = useIsMobile();
  if (!isMobile) return <>{children}</>;
  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">{title}</h1>
      </MobileHeader>
      <MobileContent>{children}</MobileContent>
    </>
  );
};
